<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端（原样不动） ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
      >
        <!-- 搜索 + 添加 + 列筛选 -->
        <div class="search-bar">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入PK盲盒名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>
          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handleAdd"
            >添加PK盲盒</el-button
          >

          <!-- 列筛选 -->
          <el-popover
            placement="bottom"
            title="显示列筛选"
            trigger="click"
            width="220"
          >
            <el-checkbox-group v-model="checkedColumns">
              <el-checkbox
                v-for="item in columnOptions"
                :key="item.prop"
                :label="item.prop"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
            <div style="text-align: right; margin-top: 8px">
              <el-button size="mini" @click="handleCheckAll">全选</el-button>
              <el-button size="mini" @click="handleClearAll">清空</el-button>
            </div>
            <el-button slot="reference" icon="el-icon-s-tools" type="info"
              >列筛选</el-button
            >
          </el-popover>
        </div>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column
            label="ID"
            prop="id"
            width="80"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="盲盒名称"
            prop="name"
            min-width="180"
            v-if="checkedColumns.includes('name')"
          />
          <el-table-column
            label="图片"
            width="120"
            align="center"
            v-if="checkedColumns.includes('image')"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.image"
                style="width: 60px; height: 60px; object-fit: cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="价格"
            prop="price"
            width="100"
            align="center"
            v-if="checkedColumns.includes('price')"
          />
          <el-table-column
            label="支出"
            prop="pay"
            width="100"
            align="center"
            v-if="checkedColumns.includes('pay')"
          />
          <el-table-column
            label="收入"
            prop="income"
            width="100"
            align="center"
            v-if="checkedColumns.includes('income')"
          />
          <!-- 新增利润列 -->
          <el-table-column
            label="利润"
            width="120"
            align="center"
            v-if="checkedColumns.includes('profit')"
          >
            <template slot-scope="scope">
              <span v-if="Number(scope.row.income) === 0">--</span>
              <span
                v-else
                :style="{
                  color:
                    scope.row.income - scope.row.pay >= 0
                      ? '#00c48c'
                      : '#f56c6c',
                }"
              >
                {{
                  (
                    ((scope.row.income - scope.row.pay) / scope.row.income) *
                    100
                  ).toFixed(2)
                }}%
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="销量"
            prop="sales"
            width="100"
            align="center"
            v-if="checkedColumns.includes('sales')"
          />
          <el-table-column
            label="排序"
            prop="sort"
            width="100"
            align="center"
            v-if="checkedColumns.includes('sort')"
          />

          <!-- 状态开关 列宽180 -->
          <el-table-column
            label="状态"
            prop="status"
            width="180"
            align="center"
            v-if="checkedColumns.includes('status')"
          >
            <template slot-scope="scope">
              <el-switch
                :value="scope.row.status == 1"
                active-text="上架"
                inactive-text="下架"
                @click.native.stop
                @change="(val) => changeStatus(scope.row.id, val)"
              />
            </template>
          </el-table-column>

          <el-table-column
            label="创建时间"
            prop="created_at"
            width="180"
            v-if="checkedColumns.includes('created_at')"
          />
          <el-table-column
            label="更新时间"
            prop="updated_at"
            width="180"
            v-if="checkedColumns.includes('updated_at')"
          />

          <!-- 操作列 -->
          <el-table-column
            label="操作"
            width="180"
            align="center"
            fixed="right"
            v-if="checkedColumns.includes('action')"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-box"
                @click.stop="openPrizeDialog(scope.row)"
                >赏品</el-button
              >
              <el-button
    type="text"
    icon="el-icon-tickets"
    @click.stop="openDrawRecord(scope.row)"
  >抽奖记录</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- 添加弹窗 -->
        <el-dialog
          title="添加PK盲盒"
          :visible.sync="dialogVisible"
          width="600px"
          @close="resetForm"
          append-to-body
        >
          <el-form
            :model="form"
            :rules="rules"
            ref="formRef"
            label-width="100px"
          >
            <el-form-item label="盲盒名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入名称"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="form.price"
                placeholder="请输入价格"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="form.sort"
                placeholder="请输入排序"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="盲盒图片" prop="image">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="openImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="form.image"
                  style="
                    border: 1px solid #eee;
                    padding: 4px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="form.image"
                    style="width: 52px; height: 52px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- 编辑弹窗 -->
        <el-dialog
          title="编辑PK盲盒"
          :visible.sync="editVisible"
          width="600px"
          @close="resetEditForm"
          append-to-body
        >
          <el-form
            :model="editForm"
            :rules="rules"
            ref="editFormRef"
            label-width="100px"
          >
            <el-form-item label="盲盒名称" prop="name">
              <el-input
                v-model="editForm.name"
                placeholder="请输入名称"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="editForm.price"
                placeholder="请输入价格"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="editForm.sort"
                placeholder="请输入排序"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="盲盒图片" prop="image">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="openEditImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="editForm.image"
                  style="
                    border: 1px solid #eee;
                    padding: 4px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="editForm.image"
                    style="width: 52px; height: 52px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="editVisible = false">取消</el-button>
            <el-button type="primary" @click="submitEdit">确认保存</el-button>
          </div>
        </el-dialog>
<!-- 抽奖记录弹窗 -->
<el-dialog
  title="盲盒抽奖记录"
  :visible.sync="drawRecordVisible"
  width="1500px"
  append-to-body
>
  <div v-loading="drawRecordLoading">
    <el-table
      :data="drawRecordList"
      border
      stripe
      size="small"
      style="width:100%"
    >
      <el-table-column label="记录ID" prop="id" width="90" align="center"/>
      <el-table-column label="用户头像" width="90" align="center">
        <template #default="scope">
          <img
            :src="scope.row.avatar"
            style="width:50px;height:50px;border-radius:50%;object-fit:cover"
          />
        </template>
      </el-table-column>
      <el-table-column label="用户昵称" prop="nickname" width="120" align="center"/>
      <el-table-column label="赏品图片" width="110" align="center">
        <template #default="scope">
          <img
            :src="scope.row.box_prize_image"
            style="width:60px;height:60px;object-fit:cover"
          />
        </template>
      </el-table-column>
      <el-table-column label="赏品名称" prop="box_prize_name" min-width="260"/>
      <el-table-column label="赏品等级" prop="level_name" width="100" align="center"/>
      <el-table-column label="单价" prop="price" width="90" align="center"/>
      <el-table-column label="兑换价" prop="recovery_price" width="100" align="center"/>
      <el-table-column label="中奖数量" prop="num" width="90" align="center"/>
      <el-table-column label="剩余次数" prop="times" width="90" align="center"/>
      <el-table-column label="订单ID" prop="box_order_id" width="120" align="center"/>
      <el-table-column label="创建时间" prop="created_at" width="180" align="center"/>
    </el-table>
    <el-pagination
      @size-change="handleDrawRecordSizeChange"
      @current-change="handleDrawRecordCurrentChange"
      :current-page="drawRecordSearch.page"
      :page-size="drawRecordSearch.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="drawRecordTotal"
      style="margin-top:15px;text-align:right"
    />
  </div>
  <div slot="footer">
    <el-button @click="drawRecordVisible = false">关闭</el-button>
  </div>
</el-dialog>
        <!-- ====================== 赏品弹窗（纯前端） ====================== -->
        <el-dialog
          title="盲盒赏品列表"
          :visible.sync="prizeDialogVisible"
          width="1400px"
          append-to-body
          @close="resetPrizeSearch"
        >
          <div
            style="
              margin-bottom: 15px;
              display: flex;
              gap: 10px;
              align-items: center;
            "
          >
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="openAddPrizeDialog"
              >添加赏品</el-button
            >
          </div>

          <div style="margin-bottom: 25px">
            <p style="font-weight: bold; margin-bottom: 8px">
              待提交赏品（可编辑概率）
            </p>
            <div v-loading="prizeLoading" element-loading-text="加载中...">
              <el-table
                :data="tempPrizeList"
                border
                stripe
                size="small"
                style="width: 100%"
              >
                <el-table-column label="赏品ID" width="100" align="center">
                  <template #default="scope">
                    {{ scope.row.goods_id || "-" }}
                  </template>
                </el-table-column>

                <el-table-column label="商品图片" width="100" align="center">
                  <template #default="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  label="商品名称"
                  prop="goods_title"
                  min-width="220"
                />

                <el-table-column label="商品类型" width="130" align="center">
                  <template #default="scope">
                    {{
                      scope.row.goods_type == 1
                        ? "真实赏品"
                        : scope.row.goods_type == 2
                        ? "虚拟赏品(钻石)"
                        : "未知"
                    }}
                  </template>
                </el-table-column>

                <el-table-column label="等级" width="140" align="center">
                  <template #default="scope">
                    <el-select
                      v-model="scope.row.level_id"
                      size="mini"
                      placeholder="选择等级"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in levelList"
                        :key="item.level_id"
                        :label="item.name"
                        :value="item.level_id"
                      />
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="概率(%)" width="130" align="center">
                  <template #default="scope">
                    <el-input
                      v-model="scope.row.probability"
                      size="mini"
                      style="width: 100px"
                      placeholder="概率"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="价格" width="130" align="center">
                  <template #default="scope">
                    <el-input
                      v-model="scope.row.price"
                      size="mini"
                      style="width: 100px"
                      placeholder="价格"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="兑换价格" width="140" align="center">
                  <template #default="scope">
                    <el-input
                      v-model="scope.row.recovery_price"
                      size="mini"
                      style="width: 100px"
                      placeholder="兑换价格"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="原始数量" width="140" align="center">
                  <template #default="scope">
                    <el-input
                      v-model="scope.row.origin_num"
                      size="mini"
                      style="width: 100px"
                      placeholder="原始数量"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="100" align="center">
                  <template #default="scope">
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      @click="delTempPrize(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div>
            <p style="font-weight: bold; margin-bottom: 8px">
              已有赏品列表（数据库）
            </p>
            <div v-loading="prizeLoading" element-loading-text="加载中...">
              <el-table
                :data="prizeList"
                border
                stripe
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  label="商品ID"
                  width="100"
                  align="center"
                  prop="goods_id"
                />
                <el-table-column
                  label="赏品ID"
                  width="100"
                  align="center"
                  prop="id"
                />
                <el-table-column label="商品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  label="商品名称"
                  prop="goods_title"
                  min-width="220"
                />

                <el-table-column
                  label="等级"
                  prop="level_name"
                  width="120"
                  align="center"
                />

                <el-table-column label="概率(%)" width="130" align="center">
                  <template slot-scope="scope">
                    {{ parseFloat(scope.row.probability || 0).toFixed(4) }}%
                  </template>
                </el-table-column>

                <el-table-column label="价格" width="130" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.price }}
                  </template>
                </el-table-column>

                <el-table-column label="兑换价格" width="140" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.recovery_price }}
                  </template>
                </el-table-column>
                <el-table-column label="商品类型" width="140" align="center">
                  <template slot-scope="scope">
                    {{
                      scope.row.goods_type == 1
                        ? "真实赏品"
                        : scope.row.goods_type == 2
                        ? "虚拟赏品(钻石)"
                        : "未知"
                    }}
                  </template>
                </el-table-column>

                <el-table-column
                  label="操作"
                  width="180"
                  align="center"
                  fixed="right"
                  key="1"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      icon="el-icon-edit"
                      @click.stop="openEditPrizeDialog(scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color: #f56c6c"
                      @click.stop="handleDelBoxPrize(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination
                @size-change="handlePrizeSizeChange"
                @current-change="handlePrizeCurrentChange"
                :current-page="prizeSearch.page"
                :page-size="prizeSearch.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="prizeTotal"
                style="margin-top: 15px; text-align: right"
              ></el-pagination>
            </div>
          </div>

          <div slot="footer" style="text-align: right">
            <el-button @click="prizeDialogVisible = false">关闭</el-button>
            <el-button
              type="primary"
              @click="submitAllPrize"
              :loading="submitLoading"
              >确认提交选中赏品</el-button
            >
          </div>

          <!-- 选择商品弹窗 -->
          <el-dialog
            title="选择商品（添加到当前盲盒）"
            :visible.sync="addPrizeDialogVisible"
            width="1100px"
            append-to-body
            @close="resetGoodsSearch"
          >
            <div
              style="
                margin-bottom: 15px;
                display: flex;
                gap: 10px;
                align-items: center;
              "
            >
              <el-input
                v-model="goodsSearch.title"
                placeholder="商品名称"
                clearable
                style="width: 220px"
              ></el-input>

              <el-select
                v-model="goodsSearch.type"
                placeholder="盲盒类型"
                clearable
                style="width: 180px"
              >
                <el-option
                  v-for="item in goodsTypeOptions"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>

              <el-select
                v-model.number="goodsSearch.level_id"
                placeholder="商品等级"
                clearable
                style="width: 180px"
              >
                <el-option
                  v-for="item in goodsLevelOptions"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>

              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getGoodsList"
                >搜索</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetGoodsSearch"
                >重置</el-button
              >
            </div>

            <div v-loading="goodsLoading" element-loading-text="加载商品中...">
              <el-table
                :data="goodsList"
                border
                stripe
                size="small"
                style="width: 100%"
                @row-click="handleSelectGoods"
                highlight-current-row
              >
                <el-table-column label="选择" width="60" align="center">
                  <template slot-scope="scope">
                    <el-checkbox
                      v-model="scope.row._checked"
                      @change="handleSelectGoods(scope.row)"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="ID" prop="id" min-width="100" />
                <el-table-column label="商品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="title"
                  min-width="220"
                />
                <el-table-column label="商品类型" width="130" align="center">
                  <template slot-scope="scope">
                    {{
                      scope.row.goods_type == 1
                        ? "真实赏品"
                        : scope.row.goods_type == 2
                        ? "虚拟赏品(钻石)"
                        : "未知"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="业务类型"
                  prop="type_name"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="等级"
                  prop="level_name"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="售价"
                  prop="price"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="创建时间"
                  prop="created_at"
                  width="180"
                />
              </el-table>

              <el-pagination
                @size-change="handleGoodsSizeChange"
                @current-change="handleGoodsCurrentChange"
                :current-page="goodsSearch.page"
                :page-size="goodsSearch.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="goodsTotal"
                style="margin-top: 15px; text-align: right"
              ></el-pagination>
            </div>

            <div slot="footer">
              <el-button @click="addPrizeDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="addSelectedToPrizeList"
                >确认添加选中商品</el-button
              >
            </div>
          </el-dialog>

          <!-- 编辑赏品弹窗 -->
          <el-dialog
            title="编辑赏品"
            :visible.sync="editPrizeDialogVisible"
            width="700px"
            append-to-body
          >
            <el-form
              :model="editPrizeForm"
              label-width="110px"
              ref="editPrizeRef"
              style="margin-top: 20px"
            >
              <el-form-item label="商品信息">
                <div style="display: flex; align-items: center; gap: 12px">
                  <img
                    :src="editPrizeForm.goods_image"
                    style="
                      width: 60px;
                      height: 60px;
                      object-fit: cover;
                      border-radius: 4px;
                    "
                  />
                  <span style="font-size: 14px; font-weight: 500">{{
                    editPrizeForm.goods_title
                  }}</span>
                </div>
              </el-form-item>
              <el-form-item label="商品ID">
                <el-input v-model="editPrizeForm.goods_id" disabled />
              </el-form-item>
              <el-form-item label="赏品ID">
                <el-input v-model="editPrizeForm.prize_id" disabled />
              </el-form-item>
              <el-form-item label="原始数量" prop="origin_num">
                <el-input
                  v-model.number="editPrizeForm.origin_num"
                  type="number"
                  placeholder="请输入原始数量"
                />
              </el-form-item>
              <el-form-item label="商品类型">
                <span :style="{ color: '#666', fontSize: '14px' }">
                  {{
                    editPrizeForm.goods_type == 1
                      ? "真实赏品"
                      : editPrizeForm.goods_type == 2
                      ? "虚拟赏品(钻石)"
                      : "未知"
                  }}
                </span>
              </el-form-item>
              <el-form-item label="展示概率" prop="probability">
                <el-input
                  v-model.number="editPrizeForm.probability"
                  type="number"
                  placeholder="请输入展示概率"
                />
              </el-form-item>

              <el-form-item label="等级" prop="level_id">
                <el-select
                  v-model="editPrizeForm.level_id"
                  placeholder="选择等级"
                >
                  <el-option
                    v-for="item in levelList"
                    :key="item.level_id"
                    :label="item.name"
                    :value="item.level_id + ''"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="价格" prop="price">
                <el-input
                  v-model.number="editPrizeForm.price"
                  type="number"
                  placeholder="请输入价格"
                />
              </el-form-item>

              <el-form-item label="兑换价格" prop="recovery_price">
                <el-input
                  v-model.number="editPrizeForm.recovery_price"
                  type="number"
                  placeholder="请输入兑换价格"
                />
              </el-form-item>
            </el-form>

            <div slot="footer" style="text-align: right">
              <el-button @click="editPrizeDialogVisible = false"
                >取消</el-button
              >
              <el-button
                type="primary"
                @click="submitEditPrize"
                :loading="editPrizeLoading"
                >确认保存</el-button
              >
            </div>
          </el-dialog>
        </el-dialog>

        <!-- 详情弹窗 -->
        <el-dialog
          title="PK盲盒详情"
          :visible.sync="detailVisible"
          width="700px"
          append-to-body
        >
          <div v-if="detailData" style="font-size: 14px; line-height: 2.2">
            <p><b>ID：</b> {{ detailData.id }}</p>
            <p><b>名称：</b> {{ detailData.name }}</p>
            <p><b>价格：</b> {{ detailData.price }}</p>
            <p><b>支出：</b> {{ detailData.pay }}</p>
            <p><b>收入：</b> {{ detailData.income }}</p>
            <!-- PC详情新增利润 -->
            <p>
              <b>利润：</b>
              <span v-if="Number(detailData.income) === 0">--</span>
              <span
                v-else
                :style="{
                  color:
                    detailData.income - detailData.pay >= 0
                      ? '#00C48C'
                      : '#F56C6C',
                }"
              >
                {{
                  (
                    ((detailData.income - detailData.pay) / detailData.income) *
                    100
                  ).toFixed(2)
                }}%
              </span>
            </p>
            <p><b>销量：</b> {{ detailData.sales }}</p>
            <p><b>排序：</b> {{ detailData.sort }}</p>
            <p><b>状态：</b> {{ detailData.status == 1 ? "上架" : "下架" }}</p>
            <p><b>创建时间：</b> {{ detailData.created_at }}</p>
            <p><b>更新时间：</b> {{ detailData.updated_at }}</p>
            <p><b>图片：</b></p>
            <img
              :src="detailData.image"
              style="
                width: 120px;
                height: 120px;
                object-fit: cover;
                border-radius: 8px;
              "
            />
          </div>
        </el-dialog>

        <!-- 图片选择 -->
        <el-dialog
          title="选择图片"
          :visible.sync="imageDialogVisible"
          width="850px"
          append-to-body
        >
          <div v-loading="imageLoading" style="padding: 10px">
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-select
                v-model.number="imageSearch.type"
                placeholder="图片类型"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in imageType"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button type="primary" @click="getImageList">筛选</el-button>
              <el-button @click="resetImageSearch">重置</el-button>
            </div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                max-height: 420px;
                overflow-y: auto;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="selectImage(img)"
                style="cursor: pointer; padding: 4px; border-radius: 6px"
                :style="{
                  border:
                    selectedImage === img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background: selectedImage === img.url ? '#f0f7ff' : '#fff',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 4px;
                  "
                />
              </div>
            </div>
            <el-pagination
              @size-change="handleImageSizeChange"
              @current-change="handleImageCurrentChange"
              :current-page="imageSearch.page"
              :page-size="imageSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="imageTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>
          <div slot="footer">
            <el-button @click="imageDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmSelectImage"
              >确认选择</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端（独立编辑弹窗） ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 移动端搜索 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="盲盒名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
          </div>
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <img :src="item.image" class="avatar" />
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">ID:{{ item.id }} | 售价¥{{ item.price }}</div>
              </div>

              <!-- 移动端状态开关 -->
              <el-switch
                :value="item.status == 1"
                active-color="#00C48C"
                inactive-color="#F56C6C"
                @click.native.stop
                @change="(val) => changeStatus(item.id, val)"
                style="transform: scale(0.85)"
              />

              <!-- 移动端编辑按钮（打开独立弹窗） -->
              <el-button
                type="text"
                icon="el-icon-edit"
                size="mini"
                @click.stop="openMobileEdit(item)"
                style="margin-left: 4px; padding: 2px 6px"
                >编辑</el-button
              >
            </div>
            <div class="card-body">
              <div>销量：{{ item.sales }}</div>
              <div>收入：{{ item.income }}</div>
              <div>支出：{{ item.pay }}</div>
              <!-- 移动端卡片利润 -->
              <div>
                利润：
                <span v-if="Number(item.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color: item.income - item.pay >= 0 ? '#00c48c' : '#f56c6c',
                  }"
                >
                  {{
                    (((item.income - item.pay) / item.income) * 100).toFixed(2)
                  }}%
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="PK盲盒详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileDetailRow" style="padding: 10px 0">
            <div style="text-align: center; margin-bottom: 15px">
              <img
                :src="mobileDetailRow.image"
                style="
                  width: 120px;
                  height: 120px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="盲盒ID">{{
                mobileDetailRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="盲盒名称">{{
                mobileDetailRow.name
              }}</el-descriptions-item>
              <el-descriptions-item label="价格"
                >¥{{ mobileDetailRow.price }}</el-descriptions-item
              >
              <el-descriptions-item label="支出">{{
                mobileDetailRow.pay
              }}</el-descriptions-item>
              <el-descriptions-item label="收入">{{
                mobileDetailRow.income
              }}</el-descriptions-item>
              <!-- 移动端详情利润 -->
              <el-descriptions-item label="利润">
                <span v-if="Number(mobileDetailRow.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color:
                      mobileDetailRow.income - mobileDetailRow.pay >= 0
                        ? '#00C48C'
                        : '#F56C6C',
                  }"
                >
                  {{
                    (
                      ((mobileDetailRow.income - mobileDetailRow.pay) / mobileDetailRow.income) * 100  ).toFixed(2)
                  }}%
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="销量">{{
                mobileDetailRow.sales
              }}</el-descriptions-item>
              <el-descriptions-item label="排序">{{
                mobileDetailRow.sort
              }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <span
                  :style="
                    mobileDetailRow.status == 1
                      ? 'color:#00C48C'
                      : 'color:#F56C6C'
                  "
                >
                  {{ mobileDetailRow.status == 1 ? "上架" : "下架" }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="创建时间">{{
                mobileDetailRow.created_at
              }}</el-descriptions-item>
              <el-descriptions-item label="更新时间">{{
                mobileDetailRow.updated_at
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- ====================== ✅ 移动端独立编辑弹窗 ====================== -->
        <el-dialog
          title="编辑盲盒"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
          @close="resetMobileEdit"
        >
          <el-form
            :model="mobileEditForm"
            :rules="rules"
            ref="mobileEditRef"
            label-width="90px"
          >
            <el-form-item label="盲盒名称" prop="name">
              <el-input
                v-model="mobileEditForm.name"
                placeholder="请输入名称"
              />
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="mobileEditForm.price"
                placeholder="请输入价格"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="mobileEditForm.sort"
                placeholder="请输入排序"
              />
            </el-form-item>
            <el-form-item label="盲盒图片">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-picture"
                  @click="openMobileImageDialog"
                  >选择图片</el-button
                >
                <div v-if="mobileEditForm.image">
                  <img
                    :src="mobileEditForm.image"
                    style="
                      width: 50px;
                      height: 50px;
                      object-fit: cover;
                      border-radius: 4px;
                    "
                  />
                </div>
              </div>
            </el-form-item>
          </el-form>

          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              gap: 8px;
              justify-content: flex-end;
            "
          >
            <el-button @click="mobileEditVisible = false">取消</el-button>
            <el-button type="primary" @click="submitMobileEdit">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../api/api.js";
export default {
  name: "PkBoxList",
  data() {
    return {
      // 移动端
      mobileDetailVisible: false,
      mobileDetailRow: null,
      mobileEditVisible: false, // 独立编辑弹窗
      mobileEditForm: {
        // 独立表单
        box_id: "",
        name: "",
        price: "",
        sort: "",
        image: "",
      },

      loading: false,
      tableData: [],
      pageTotal: 0,
      searchParams: { page: 1, page_size: 10, name: "" },

      // 列筛选
      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "盲盒名称", prop: "name" },
        { label: "图片", prop: "image" },
        { label: "价格", prop: "price" },
        { label: "支出", prop: "pay" },
        { label: "收入", prop: "income" },
        { label: "利润", prop: "profit" },
        { label: "销量", prop: "sales" },
        { label: "排序", prop: "sort" },
        { label: "状态", prop: "status" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新时间", prop: "updated_at" },
        { label: "操作", prop: "action" },
      ],
      checkedColumns: [
        "id",
        "name",
        "image",
        "price",
        "pay",
        "income",
        "profit",
        "sales",
        "sort",
        "status",
        "created_at",
        "updated_at",
        "action",
      ],

      // 添加
      dialogVisible: false,
      form: { name: "", price: "", sort: "", image: "" },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        image: [{ required: true, message: "请选择图片", trigger: "change" }],
      },

      // 编辑（PC）
      editVisible: false,
      editForm: { box_id: "", name: "", price: "", sort: "", image: "" },

      // 详情
      detailVisible: false,
      detailData: null,

      // 图片
      imageDialogVisible: false,
      imageLoading: false,
      imageList: [],
      imageTotal: 0,
      imageSearch: { page: 1, page_size: 10, type: "" },
      imageType: [],
      selectedImage: "",
      isEditImage: false,
// 抽奖记录弹窗
drawRecordVisible: false,
drawRecordLoading: false,
drawRecordList: [],
drawRecordTotal: 0,
currentDrawBoxId: null,
drawRecordSearch: {
  page: 1,
  page_size: 10,
  type: 10,
  box_id: "",
  box: ""
},
      // 赏品弹窗配套数据
      prizeDialogVisible: false,
      prizeLoading: false,
      prizeList: [],
      tempPrizeList: [],
      prizeTotal: 0,
      currentBoxId: null,
      prizeSearch: { page: 1, page_size: 10, type: "", level_id: "" },
      prizeTypeOptions: [],
      prizeLevelOptions: [],
      addPrizeDialogVisible: false,
      goodsLoading: false,
      goodsList: [],
      goodsTotal: 0,
      goodsTypeOptions: [],
      goodsLevelOptions: [],
      goodsSearch: {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
      },
      editPrizeDialogVisible: false,
      editPrizeLoading: false,
      editPrizeForm: {
        prize_id: "",
        origin_num: "",
        probability: "",
        goods_id: "",
        level_id: "",
        price: "",
        recovery_price: "",
        goods_type: "",
        goods_image: "",
        goods_title: "",
      },
      selectedGoodsIds: [],
      addedGoodsIds: [],
      submitLoading: false,

      // 接口返回的等级列表（替换原来写死的）
      levelList: [],
    };
  },
  created() {
    this.getList();
  },
  watch: {
    "goodsSearch.type"(newVal) {
      let target = this.goodsTypeOptions.find((item) => item.type == newVal);
      this.goodsLevelOptions = target ? target.goods_level : [];
      this.goodsSearch.level_id = "";
    },
  },
  methods: {
    // ====================== 移动端方法 ======================
    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },

    // 打开移动端独立编辑弹窗
    openMobileEdit(row) {
      this.mobileEditForm = {
        box_id: row.id,
        name: row.name,
        price: row.price,
        sort: row.sort,
        image: row.image,
      };
      this.mobileEditVisible = true;
    },

    // 移动端编辑图片选择
    openMobileImageDialog() {
      this.isEditImage = true;
      this.imageDialogVisible = true;
      this.selectedImage = "";
      this.getImageList();
    },

    // 移动端编辑表单重置
    resetMobileEdit() {
      this.mobileEditForm = {
        box_id: "",
        name: "",
        price: "",
        sort: "",
        image: "",
      };
      this.$nextTick(() => {
        if (this.$refs.mobileEditRef) {
          this.$refs.mobileEditRef.clearValidate();
        }
      });
    },

    // 提交移动端编辑
    async submitMobileEdit() {
      const valid = await this.$refs.mobileEditRef.validate();
      if (!valid) return;

      this.loading = true;
      try {
        await api.pkBox.edit(this.mobileEditForm);
        this.mobileEditVisible = false;
        this.getList();
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },

    // 列表
    getList() {
      this.loading = true;
      api.pkBox
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code === "1000") {
            this.tableData = res.data.data.data || [];
            this.pageTotal = res.data.data.total || 0;

            // 从接口获取等级列表并赋值
            this.levelList = (res.data.data.level || []).map((item) => ({
              level_id: item.level_id,
              name: item.name,
            }));
          }
        })
        .finally(() => (this.loading = false));
    },
    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, name: "" };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((item) => item.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },

    // 添加
    handleAdd() {
      this.resetForm();
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = { name: "", price: "", sort: "", image: "" };
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        api.pkBox
          .add(this.form)
          .then((res) => {
            if (res.data.code === "1000") {
              this.dialogVisible = false;
              this.getList();
            }
          })
          .finally(() => (this.loading = false));
      });
    },

    // PC编辑
    handleEdit(row) {
      this.editForm = {
        box_id: row.id,
        name: row.name,
        price: row.price,
        sort: row.sort,
        image: row.image,
      };
      this.editVisible = true;
    },
    resetEditForm() {
      this.editForm = { box_id: "", name: "", price: "", sort: "", image: "" };
      this.$nextTick(() => {
        if (this.$refs.editFormRef) this.$refs.editFormRef.clearValidate();
      });
    },
    submitEdit() {
      this.$refs.editFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        api.pkBox
          .edit(this.editForm)
          .then((res) => {
            if (res.data.code === "1000") {
              this.editVisible = false;
              this.getList();
            }
          })
          .finally(() => (this.loading = false));
      });
    },

    // 状态修改
    async changeStatus(box_id, val) {
      const status = val ? 1 : 0;
      try {
        await api.pkBox.status({ box_id, status });
        this.getList();
      } catch (err) {}
    },

    // 点击行查看详情
    handleRowClick(row) {
      this.detailData = row;
      this.detailVisible = true;
    },

    // 图片选择
    openImageDialog() {
      this.isEditImage = false;
      this.imageDialogVisible = true;
      this.selectedImage = "";
      this.getImageList();
    },
    openEditImageDialog() {
      this.isEditImage = true;
      this.imageDialogVisible = true;
      this.selectedImage = "";
      this.getImageList();
    },
    getImageList() {
      this.imageLoading = true;
      api.images
        .index({ params: this.imageSearch })
        .then((res) => {
          if (res.data.code === "1000") {
            this.imageList = res.data.data.data || [];
            this.imageTotal = res.data.data.total || 0;
            this.imageType = res.data.data.image_type || [];
          }
        })
        .finally(() => (this.imageLoading = false));
    },
    selectImage(img) {
      this.selectedImage = img.url;
    },
    confirmSelectImage() {
      if (!this.selectedImage) return this.$message.warning("请选择图片");
      if (this.isEditImage) {
        this.editForm.image = this.selectedImage;
        this.mobileEditForm.image = this.selectedImage; // 移动端也赋值
      } else {
        this.form.image = this.selectedImage;
      }
      this.imageDialogVisible = false;
    },
    resetImageSearch() {
      this.imageSearch = { page: 1, page_size: 10, type: "" };
      this.getImageList();
    },
    handleImageSizeChange(val) {
      this.imageSearch.page_size = val;
      this.getImageList();
    },
    handleImageCurrentChange(val) {
      this.imageSearch.page = val;
      this.getImageList();
    },

    // 赏品列表
    openPrizeDialog(row) {
      if (this.currentBoxId != row.id) {
        this.tempPrizeList = [];
        this.addedGoodsIds = [];
        this.selectedGoodsIds = [];
      }
      this.currentBoxId = row.id;
      this.prizeDialogVisible = true;
      this.goodsList.forEach((item) => (item._checked = false));
      this.resetPrizeSearch();
    },
    getBoxPrizeList() {
      if (!this.currentBoxId) return;
      this.prizeLoading = true;
      api.pkBox
        .pkBoxPrizeList({
          params: {
            box_id: this.currentBoxId,
            page: this.prizeSearch.page,
            page_size: this.prizeSearch.page_size,
          },
        })
        .then((res) => {
          if (res.data.code === "1000") {
            this.prizeList = res.data.data.data || [];
            this.prizeTotal = res.data.data.total || 0;
          }
        })
        .finally(() => {
          this.prizeLoading = false;
        });
    },
    resetPrizeSearch() {
      this.prizeSearch = { page: 1, page_size: 10, type: "", level_id: "" };
      this.getBoxPrizeList();
    },
    handlePrizeSizeChange(val) {
      this.prizeSearch.page_size = val;
      this.getBoxPrizeList();
    },
    handlePrizeCurrentChange(val) {
      this.prizeSearch.page = val;
      this.getBoxPrizeList();
    },
    openAddPrizeDialog() {
      this.addPrizeDialogVisible = true;
      this.resetGoodsSearch();
    },
    getGoodsList() {
      this.goodsLoading = true;
      let params = { ...this.goodsSearch, flag: 10 };
      api.goods
        .index({ params })
        .then((res) => {
          if (res.data.code === "1000") {
            let data = res.data.data;
            this.goodsList = data.data || [];
            this.goodsTotal = data.total || 0;
            this.goodsTypeOptions = data.goods_level || [];

            let currentType = this.goodsSearch.type;
            let targetLevelGroup = this.goodsTypeOptions.find(
              (t) => t.type == currentType
            );
            this.goodsLevelOptions = targetLevelGroup
              ? targetLevelGroup.goods_level
              : [];

            this.goodsList.forEach((item) => {
              const isChecked = this.selectedGoodsIds.includes(item.id);
              this.$set(item, "_checked", isChecked);
            });
          }
        })
        .finally(() => {
          this.goodsLoading = false;
        });
    },
    handleSelectGoods(row) {
      this.$set(row, "_checked", !row._checked);
      if (row._checked) {
        if (!this.selectedGoodsIds.includes(row.id))
          this.selectedGoodsIds.push(row.id);
      } else {
        this.selectedGoodsIds = this.selectedGoodsIds.filter(
          (id) => id !== row.id
        );
      }
    },
    addSelectedToPrizeList() {
      if (this.selectedGoodsIds.length === 0) {
        return this.$message.warning("请选择商品");
      }
      let selectedGoods = this.goodsList.filter((g) => g._checked);
      selectedGoods.forEach((g) => {
        const isRealExist = this.tempPrizeList.some(
          (item) => item.goods_id == g.id && item.goods_type === 1
        );
        if (g.goods_type === 1 && isRealExist) {
          this.$message.warning(`真实赏品【${g.title}】已存在，不可重复添加`);
          return;
        }

        this.tempPrizeList.push({
          goods_id: g.id,
          goods_title: g.title,
          goods_image: g.image,
          level_id: g.level_id,
          level_name: g.level_name,
          goods_type: g.goods_type || 1,
          price: g.price,
          recovery_price: g.price,
          origin_num: 0,
          probability: 0,
        });
      });
      this.addPrizeDialogVisible = false;
      this.$message.success("添加成功");
    },
    delTempPrize(row) {
      this.tempPrizeList = this.tempPrizeList.filter(
        (i) => !(i.goods_id == row.goods_id && i.goods_type == row.goods_type)
      );
      this.selectedGoodsIds = this.selectedGoodsIds.filter(
        (id) => id != row.goods_id
      );
    },
    submitAllPrize() {
      if (this.tempPrizeList.length == 0) {
        this.$message.warning("请添加赏品");
        return;
      }
      if (!this.currentBoxId) {
        this.$message.warning("未获取到盲盒ID");
        return;
      }

      const prize_info = this.tempPrizeList.map((item) => ({
        goods_id: item.goods_id,
        probability: parseFloat(item.probability) || 0,
        level_id: item.level_id,
        price: parseFloat(item.price) || 0,
        recovery_price: parseFloat(item.recovery_price) || 0,
        goods_type: item.goods_type || 1,
        type: 0,
      }));

      this.submitLoading = true;
      api.pkBox
        .addPkBoxPrize({
          box_id: this.currentBoxId,
          prize_info: JSON.stringify(prize_info),
        })
        .then((res) => {
          if (res.data.code === "1000") {
            this.tempPrizeList = [];
            this.getBoxPrizeList();
          }
        })
        .catch(() => {
          this.$message.error("请求失败");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    resetGoodsSearch() {
      this.goodsSearch = {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
      };
      this.goodsLevelOptions = [];
      this.selectedGoodsIds = this.tempPrizeList.map((item) => item.goods_id);
      this.getGoodsList();
    },
    handleGoodsSizeChange(val) {
      this.goodsSearch.page_size = val;
      this.getGoodsList();
    },
    handleGoodsCurrentChange(val) {
      this.goodsSearch.page = val;
      this.getGoodsList();
    },
    openEditPrizeDialog(row) {
      this.editPrizeForm = {
        prize_id: row.id + "",
        probability: row.probability + "",
        goods_id: row.goods_id + "",
        level_id: row.level_id + "",
        price: row.price + "",
        recovery_price: row.recovery_price + "",
        goods_type: row.goods_type + "",
        goods_image: row.goods_image,
        goods_title: row.goods_title,
      };
      this.editPrizeDialogVisible = true;
    },
    submitEditPrize() {
      this.editPrizeLoading = true;
      let params = {
        prize_id: this.editPrizeForm.prize_id,
        probability: this.editPrizeForm.probability,
        goods_id: this.editPrizeForm.goods_id,
        level_id: this.editPrizeForm.level_id,
        price: this.editPrizeForm.price,
        recovery_price: this.editPrizeForm.recovery_price,
        goods_type: this.editPrizeForm.goods_type,
      };
      api.pkBox
        .editPkBoxPrize(params)
        .then((res) => {
          if (res.data.code === "1000") {
            this.editPrizeDialogVisible = false;
            this.getBoxPrizeList();
          }
        })
        .catch(() => {
          this.$message.error("请求失败");
        })
        .finally(() => {
          this.editPrizeLoading = false;
        });
    },
    handleDelBoxPrize(row) {
      this.$confirm("确定删除该赏品？", "提示")
        .then(() => {
          api.pkBox.delPkBoxPrize({ prize_id: row.id }).then((res) => {
            if (res.data.code === "1000") {
              this.getBoxPrizeList();
            }
          });
        })
        .catch(() => {});
    },
    // 打开抽奖记录弹窗
openDrawRecord(row) {
  this.currentDrawBoxId = row.id
  this.drawRecordSearch.box_id = row.id
  this.drawRecordSearch.page = 1
  this.drawRecordVisible = true
  this.getDrawRecordList()
},
// 获取抽奖记录列表
getDrawRecordList() {
  this.drawRecordLoading = true
  const params = {
    ...this.drawRecordSearch
  }
  api.blindCate.boxDrawRecord({ params })
    .then(res => {
      if (res.data.code === '1000') {
        this.drawRecordList = res.data.data.data || []
        this.drawRecordTotal = res.data.data.total || 0
      }
    })
    .finally(() => {
      this.drawRecordLoading = false
    })
},
// 分页切换
handleDrawRecordSizeChange(val) {
  this.drawRecordSearch.page_size = val
  this.getDrawRecordList()
},
handleDrawRecordCurrentChange(val) {
  this.drawRecordSearch.page = val
  this.getDrawRecordList()
},
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/pk/index.vue